export const CELL = 16;

export const BIOMES = [
  { code: "W", name: "Deep water", color: "#1D3B5C" },
  { code: "S", name: "Shallows", color: "#2F6690" },
  { code: "B", name: "Beach", color: "#D8C38F" },
  { code: "P", name: "Plains", color: "#8FAE5D" },
  { code: "F", name: "Forest", color: "#3F6B3A" },
  { code: "J", name: "Jungle", color: "#2B5A33" },
  { code: "H", name: "Swamp", color: "#56654A" },
  { code: "D", name: "Desert", color: "#D4A95F" },
  { code: "M", name: "Mountains", color: "#7D7468" },
  { code: "T", name: "Tundra", color: "#A3A897" },
  { code: "N", name: "Snow", color: "#E8ECEF" },
];
const COLORS = Object.fromEntries(BIOMES.map((b) => [b.code, b.color]));

const hash = (i) => {
  let h = (i * 2654435761) >>> 0;
  h ^= h >>> 15;
  return (h % 1000) / 1000;
};

const shade = (hex, f) => {
  const n = parseInt(hex.slice(1), 16);
  const ch = (v) => Math.max(0, Math.min(255, Math.round(v * f)));
  return `rgb(${ch(n >> 16)},${ch((n >> 8) & 255)},${ch(n & 255)})`;
};

export function drawCell(ctx, grid, cols, i, cell) {
  const x = i % cols, y = Math.floor(i / cols);
  const code = grid[i];
  ctx.fillStyle = shade(COLORS[code] || "#000000", 0.93 + hash(i) * 0.14);
  ctx.fillRect(x * cell, y * cell, cell, cell);
  if (code === "M" && cell >= 8) {
    ctx.fillStyle = "rgba(255,255,255,0.18)";
    ctx.beginPath();
    ctx.moveTo(x * cell + cell * 0.15, y * cell + cell * 0.85);
    ctx.lineTo(x * cell + cell * 0.5, y * cell + cell * 0.2);
    ctx.lineTo(x * cell + cell * 0.85, y * cell + cell * 0.85);
    ctx.fill();
  }
  if ((code === "F" || code === "J") && cell >= 8 && hash(i + 7) > 0.45) {
    ctx.fillStyle = "rgba(0,0,0,0.22)";
    ctx.beginPath();
    ctx.arc(x * cell + cell * (0.3 + hash(i + 3) * 0.4), y * cell + cell * (0.3 + hash(i + 5) * 0.4), cell * 0.22, 0, Math.PI * 2);
    ctx.fill();
  }
}

export function drawGrid(ctx, grid, cols, rows, cell) {
  for (let i = 0; i < cols * rows; i++) drawCell(ctx, grid, cols, i, cell);
}

export function renderGridUrl(grid, cols, rows) {
  const c = document.createElement("canvas");
  c.width = cols * CELL;
  c.height = rows * CELL;
  drawGrid(c.getContext("2d"), grid, cols, rows, CELL);
  return c.toDataURL("image/png");
}
